// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"b406d95c","540":"74130b3d","871":"b0d95bf5"}[chunkId] + ".chunk.css";
};